var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPauseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76 14.5H3.34C2.1 14.5 1.5 13.9267 1.5 12.74V3.26C1.5 2.07333 2.1 1.5 3.34 1.5H5.76C7 1.5 7.6 2.07333 7.6 3.26V12.74C7.6 13.9267 7 14.5 5.76 14.5ZM3.34 2.5C2.62 2.5 2.5 2.68 2.5 3.26V12.74C2.5 13.32 2.61333 13.5 3.34 13.5H5.76C6.48 13.5 6.6 13.32 6.6 12.74V3.26C6.6 2.68 6.48667 2.5 5.76 2.5H3.34Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6604 14.5H10.2404C9.00039 14.5 8.40039 13.9267 8.40039 12.74V3.26C8.40039 2.07333 9.00039 1.5 10.2404 1.5H12.6604C13.9004 1.5 14.5004 2.07333 14.5004 3.26V12.74C14.5004 13.9267 13.9004 14.5 12.6604 14.5ZM10.2404 2.5C9.52039 2.5 9.40039 2.68 9.40039 3.26V12.74C9.40039 13.32 9.51372 13.5 10.2404 13.5H12.6604C13.3804 13.5 13.5004 13.32 13.5004 12.74V3.26C13.5004 2.68 13.3871 2.5 12.6604 2.5H10.2404Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseIcon);
export default __webpack_public_path__ + "static/media/pauseIcon.8e04a7a375cce874cd9e1a0740b77816.svg";
export { ForwardRef as ReactComponent };